import eventService from '@/services/http/content/EventService'

export const events = () => {
  return {
    namespaced: true,
    state: {
      loading: false,
      events: [],
      event: undefined
    },
    mutations: {
      SET_LOADING (state, loading) {
        state.loading = loading
      },
      SET_EVENTS (state, events) {
        state.events = events
      },
      SET_EVENT (state, event) {
        state.event = event
      }
    },
    actions: {
      async fetchEvents ({ commit }) {
        const events = await eventService.fetchEvents()
        commit('SET_EVENTS', events)

      },
      async fetchEvent ({ commit }, id) {
        const event = await eventService.fetchEvent(id)
        console.log('event: ', event)
        commit('SET_EVENT', event)

      }
    }
  }
}
